export const billerListPayload = {
  data: {
    status: 'success',
    payload: {
      id: 'c11fddac-4273-11ea-a17d-0242ac110002',
      public_id: 'SVC-c11fddac',
      name: 'Credit Card',
      category: 'Finance',
      icon_abs_url:
        'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1580290960753.png',
      banner_abs_url: [
        'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1580287545747.png',
      ],
      default_form: {
        form_id: 'b67f063d-41bb-4302-a2fa-45596bbd088a',
        name: 'Credit Card',
      },
      is_active: true,
      created_at: '2020-01-29T15:45:51+07:00',
      updated_at: '2020-02-11T10:47:10+07:00',
    },
  },
  status: 200,
  statusText: '',
  headers: { 'content-length': '566', 'content-type': 'application/json' },
  config: {
    url: 'services/c11fddac-4273-11ea-a17d-0242ac110002',
    method: 'get',
    headers: {
      Authorization:
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjE3MWVmNTYyLWY0ODYtMTFlOS04NDFjLTAyNDJhYzExMDAwMiIsImRhbmFQdWJsaWNJZCI6IjIwMTkxMDE0MTExMjE1ODMwMTY5REFOQVczSUQ4Mjg5MDAyMDA3MzMiLCJleHAiOjE1ODQwNzkxODcsImlhdCI6MTU4Mjg2OTU4N30.A4pO1C5hzFQzRUHvYNusa6G5RvE5_-cOw0gSvJhh5lo',
    },
    baseURL: 'https://stag-anteiku.innov8.id/v1',
    transformRequest: [null],
    transformResponse: [null],
    timeout: 5000,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
  },
  request: {
    __sentry_xhr__: {
      method: 'GET',
      url:
        'https://stag-anteiku.innov8.id/v1/services/c11fddac-4273-11ea-a17d-0242ac110002',
      status_code: 200,
    },
  },
};

export const billerList = [
  {
    id: '064aca78-5228-11ea-bc1e-0242ac110002',
    name: 'GoPay',
    icon_abs_url:
      'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1585277418592.png',
    pground_status: '2',
    skyw_status: '2',
  },
  {
    id: '1474cda4-5228-11ea-bc1e-0242ac110002',
    name: 'Link Aja!',
    icon_abs_url:
      'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1585277431494.png',
    pground_status: '2',
    skyw_status: '2',
  },
  {
    id: '213e4bbd-5228-11ea-a37f-0242ac110002',
    name: 'OVO',
    icon_abs_url:
      'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1587978340025.png',
    pground_status: '2',
    skyw_status: '2',
  },
  {
    id: 'f35adfc1-5230-11ea-a37f-0242ac110002',
    name: 'Shopee Pay',
    icon_abs_url:
      'https://innovation-anteiku-s3.s3-ap-southeast-1.amazonaws.com/stag/images/FILES_1585649856875.png',
    pground_status: '2',
    skyw_status: '3',
  },
];

export const checkoutSample = {
  sales_order_id: 'b5599d5f-e845-11ea-8ba0-0242ac110002',
  biller_id: '064aca78-5228-11ea-bc1e-0242ac110002',
  beneficiary_account_number: '000812121213',
  beneficiary_full_name: 'DEFAULT ACCOUNT HOLDER',
  est_processed_time: '2020-09-01T16:14:28+07:00',
  transaction_amount: '50000',
  admin_fee: '1500',
  total_amount: '51500',
  dana_payer_info: {
    is_kyc: true,
    balance: {
      currency: 'IDR',
      amount: '9106283',
    },
    nickname: 'R.NIRMA NURMALASARI',
  },
  dana_available_payment_methods: {
    balance: {
      pay_method: 'BALANCE',
      pay_option: 'BALANCE',
      fund_channel: {
        inst_id: 'DANAW3ID',
      },
      min_limit: {
        currency: 'IDR',
        amount: '10000',
      },
      max_limit: {
        currency: 'IDR',
        amount: '9106283',
      },
    },
    saved_cards: [
      {
        pay_method: 'DEBIT_CARD',
        pay_option: 'DEBIT_CARD_MASTER',
        fund_channel: {
          inst_id: 'BCAC1ID',
          inst_name: 'BCA BANK CENTRAL ASIA',
          inst_local_name: 'BCA',
        },
        min_limit: {
          currency: 'IDR',
          amount: '10000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '50000000',
        },
        card_index_no: '202004175927081420b2ae06219d91e40744591e81412',
        masked_card_no: '515291******7153',
      },
      {
        pay_method: 'DEBIT_CARD',
        pay_option: 'DEBIT_CARD_VISA',
        fund_channel: {},
        min_limit: {
          currency: 'IDR',
          amount: '10000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '50000000',
        },
        card_index_no: '2019120300640689f06cfd7dc8d73c6384fc9211f006e',
        masked_card_no: '466160******2947',
      },
      {
        pay_method: 'DEBIT_CARD',
        pay_option: 'DEBIT_CARD_MASTER',
        fund_channel: {
          inst_id: 'CIMBC1ID',
          inst_name: 'CIMB NIAGA BANK',
          inst_local_name: 'CIMB Niaga',
        },
        min_limit: {
          currency: 'IDR',
          amount: '10000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '50000000',
        },
        card_index_no: '2019052202050bd4b7e25da451642f61d28bf35614e0f',
        masked_card_no: '557692******2993',
      },
    ],
    new_card_options: [
      {
        pay_method: 'DEBIT_CARD',
        fund_channel: {},
        min_limit: {
          currency: 'IDR',
          amount: '10000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '50000000',
        },
      },
      {
        pay_method: 'DIRECT_DEBIT_DEBIT_CARD',
        pay_option: 'DD_DEBIT_CARD_PANI',
        fund_channel: {
          inst_id: 'PANIC1ID',
          inst_name: 'PANIN BANK',
          inst_local_name: 'Panin',
        },
        min_limit: {
          currency: 'IDR',
          value: '1000000',
          amount: '10.000',
        },
        max_limit: {
          currency: 'IDR',
          value: '100000000',
          amount: '1.000.000',
        },
      },
    ],
  },
};

export const checkoutParamSample = {
  biller_id: '064aca78-5228-11ea-bc1e-0242ac110002',
  customer_number: '70001081212121212',
  transaction_amount: '50000',
};

export const checkoutParamNameSample = {
  biller_id: '064aca78-5228-11ea-bc1e-0242ac110002',
  customer_number: '70001081212121212',
  transaction_amount: '50000',
  payer_name: 'ryan',
};

export const errorNeedSenderName = {
  response: {
    data: {
      message: {
        status: '-15000',
        title: 'PAYER_INFO_NOT_FOUND',
        detail: 'Payer info not found',
        additional_info: {
          payer_nickname: 'ida namida',
        },
      },
    },
  },
};

export const errorAccountNotFound = {
  response: {
    data: {
      message: {
        status: '-9000',
        title: 'TRANSFER_DESTINATION_NOT_FOUND',
        detail: 'Payer info not found',
        additional_info: {
          payer_nickname: 'ida namida',
        },
      },
    },
  },
};

export const errorOthers = {
  response: {
    data: {
      message: {
        title: 'SYSTEM_ERROR',
        detail: 'Payer info not found',
        additional_info: {
          payer_nickname: 'ida namida',
        },
      },
    },
  },
};

export const checkoutSampleNonKycSavedCards = {
  sales_order_id: 'SO-1e5037b5',
  biller_id: 'BILL-f35adfc4',
  transaction_amount: '100000',
  admin_fee: '6500',
  total_amount: '106500',
  beneficiary_full_name: 'Ida Namida',
  beneficiary_account_number: '34567890',
  dana_payer_info: {
    is_kyc: false,
    balance: {
      amount: '',
      currency: 'IDR',
    },
    nickname: 'Ida Namida',
  },
  dana_available_payment_methods: {
    balance: {
      pay_method: 'BALANCE',
      pay_option: 'BALANCE',
      fund_channel: {
        inst_id: 'DANAW3ID',
        inst_name: '',
        inst_local_name: '',
        bank_id: '',
        bank_name: '',
      },
      min_limit: {
        currency: 'IDR',
        amount: '1000000',
      },
      max_limit: {
        currency: 'IDR',
        amount: '703777100',
      },
      card_index_no: '',
      masked_card_no: '',
    },
    saved_cards: [
      {
        pay_method: 'DEBIT_CARD',
        pay_option: 'DEBIT_CARD_VISA',
        fund_channel: {
          inst_id: 'BNLIC1ID',
          inst_name: 'PERMATA BANK',
          inst_local_name: 'Permata',
          bank_id: '',
          bank_name: '',
        },
        min_limit: {
          currency: 'IDR',
          amount: '1000000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '5000000000',
        },
        card_index_no: '202004047524070ec277156c0df205c2410498a36ecbf',
        masked_card_no: '489385******5519',
      },
    ],
    new_card_options: [
      {
        pay_method: 'DEBIT_CARD',
        pay_option: '',
        fund_channel: {
          inst_id: '',
        },
        min_limit: {
          currency: 'IDR',
          amount: '1000000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '5000000000',
        },
        FundType: 'TRANSFER_B2IB',
      },
    ],
  },
};

export const checkoutSampleNonKycNoSavedCards = {
  sales_order_id: 'SO-1e5037b7',
  biller_id: 'BILL-f35adfc4',
  transaction_amount: '100000',
  admin_fee: '6500',
  total_amount: '106500',
  beneficiary_full_name: 'Ida Namida',
  beneficiary_account_number: '34567890',
  dana_payer_info: {
    is_kyc: false,
    balance: {
      amount: '',
      currency: 'IDR',
    },
    nickname: 'Ida Namida',
  },
  dana_available_payment_methods: {
    balance: {
      pay_method: 'BALANCE',
      pay_option: 'BALANCE',
      fund_channel: {
        inst_id: 'DANAW3ID',
        inst_name: '',
        inst_local_name: '',
        bank_id: '',
        bank_name: '',
      },
      min_limit: {
        currency: 'IDR',
        amount: '1000000',
      },
      max_limit: {
        currency: 'IDR',
        amount: '703777100',
      },
      card_index_no: '',
      masked_card_no: '',
    },
    saved_cards: [],
    new_card_options: [
      {
        pay_method: 'DEBIT_CARD',
        pay_option: '',
        fund_channel: {
          inst_id: '',
        },
        min_limit: {
          currency: 'IDR',
          amount: '1000000',
        },
        max_limit: {
          currency: 'IDR',
          amount: '5000000000',
        },
        FundType: 'TRANSFER_B2IB',
      },
    ],
  },
};

export const checkoutSampleKycLimitExceed = {
  sales_order_id: 'SO-1e5037b7',
  biller_id: 'BILL-f35adfc4',
  transaction_amount: '100000',
  admin_fee: '6500',
  total_amount: '106500',
  beneficiary_full_name: 'Ida Namida',
  beneficiary_account_number: '34567890',
  dana_payer_info: {
    is_kyc: true,
    balance: {
      amount: '',
      currency: 'IDR',
    },
    nickname: 'Ida Namida',
  },
  dana_available_payment_methods: {
    balance: {
      pay_method: 'BALANCE',
      pay_option: 'BALANCE',
      fund_channel: {
        inst_id: 'DANAW3ID',
        inst_name: '',
        inst_local_name: '',
        bank_id: '',
        bank_name: '',
      },
      min_limit: {
        currency: 'IDR',
        amount: '10000',
      },
      max_limit: {
        currency: 'IDR',
        amount: '100000',
      },
      card_index_no: '',
      masked_card_no: '',
    },
    saved_cards: [],
    new_card_options: [],
  },
};

export const checkoutSampleKycNoBalance = {
  sales_order_id: 'SO-1e5037b7',
  biller_id: 'BILL-f35adfc4',
  transaction_amount: '100000',
  admin_fee: '6500',
  total_amount: '106500',
  beneficiary_full_name: 'Ida Namida',
  beneficiary_account_number: '34567890',
  dana_payer_info: {
    is_kyc: true,
    balance: {
      amount: '25000',
      currency: 'IDR',
    },
    nickname: 'Ida Namida',
  },
  dana_available_payment_methods: {
    balance: {
      pay_method: 'BALANCE',
      pay_option: 'BALANCE',
      fund_channel: {
        inst_id: 'DANAW3ID',
        inst_name: '',
        inst_local_name: '',
        bank_id: '',
        bank_name: '',
      },
      min_limit: {
        currency: 'IDR',
        amount: '10000',
      },
      max_limit: {
        currency: 'IDR',
        amount: '200000',
      },
      card_index_no: '',
      masked_card_no: '',
    },
    saved_cards: [],
    new_card_options: [],
  },
};
